import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import cx from 'classnames';

const CheckBox = ({
    title = '',
    className = '',
    id = 'dscheckbox',
    size = 'small',
    reversed = false,
    checked = false,
    onClick = () => {},
    ...props
}) => (
    <div className={cx('ds-checkbox', className)} onClick={onClick}>
        <div className={cx('checkmark', size, reversed && 'reversed')}>
            <input type="checkbox" id={id || new uniqid()} checked={checked} {...props} />
            <label className="check-box" htmlFor={id} />
        </div>
        {title && <span className="checktitle truncate text-vcenter ms-2">{title}</span>}
    </div>
);

CheckBox.propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
    checked: PropTypes.bool,
    reversed: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    size: PropTypes.oneOf(['tiny', 'small', 'regular', 'large']),
    onChange: PropTypes.func,
    onClick: PropTypes.func,
};

export default CheckBox;
